import type { Ref } from 'react';
import { useEffect, useImperativeHandle, useRef } from 'react';

interface TextFieldProps {
  id?: string;
  name: string;
  value?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  isLoading?: boolean;
  readOnly?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export const TextField = ({
  id,
  name,
  value,
  placeholder,
  onChange,
  onBlur,
  autoFocus,
  isLoading,
  readOnly,
  ref,
}: TextFieldProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);

  return (
    <input
      id={id}
      ref={inputRef}
      value={value ?? ''}
      name={name}
      placeholder={placeholder}
      disabled={isLoading}
      className={`form-input-m form-input ${isLoading ? 'bg-gray:300 animate-pulse dark:bg-gray-700' : ''}`}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      readOnly={readOnly}
    />
  );
};
